import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Card from '../../../../../../shared/components/Card';
import {
  CardLabel,
  CardValue,
  LabelAndValueContainer,
} from '../../../../../../shared/components/Card/components/CardComponents';
import theme from '../../../../../../styles/theme';
import checkValue from '../../../../../../utils/values';
import BarChart from '../components/CardWithBarChart/components/BarChart';
import Frame from './components/Frame';

export default function TevDashboard() {
  const tevFaresState = useSelector((reducer: IReducer) => reducer.tevFares);
  return (
    <Frame.Base isActive={tevFaresState.isActive}>
      <Card
        isActive
        title="Recebidas por clientes"
        display="flex"
        flexDirection="column"
        gridArea="tarifasRecebidasClientes"
        padding=""
        justifyContent="flex-start"
        width="100%"
        height="100%"
        maxWidth="300px"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Quantidade</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {tevFaresState.tevReceived.quantity}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Valor</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(tevFaresState.tevReceived.value).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive
        title={
          tevFaresState.partner
            ? 'Tarifas repassadas'
            : 'Recebidas por White Label'
        }
        display="flex"
        flexDirection="column"
        padding=""
        gridArea="tarifasRecebidas"
        maxWidth="300px"
        justifyContent="start"
        width="100%"
        height="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Quantidade</CardLabel>
          <CardValue
            color={
              !tevFaresState.partner ? theme.colors.emphasis : theme.colors.red
            }>
            {tevFaresState.tevSent.quantity}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Valor</CardLabel>
          <CardValue
            color={
              !tevFaresState.partner ? theme.colors.emphasis : theme.colors.red
            }>
            {checkValue(tevFaresState.tevSent.value).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive
        title="TEVS Movimentadas nos Últimos 12 Meses"
        gridArea="lastTwelveMonths"
        display="flex"
        flexDirection="column"
        justifyContent="start"
        width="100%"
        height="100%"
        minHeight="286px"
        backgroundColor="#FFFFFF">
        <BarChart
          data={tevFaresState.lastTwelveMonths}
          hasOneData={false}
          firstValueColor={theme.colors.emphasis}
          secondValueColor={theme.colors.red}
          labelForTwoDatas={{
            firstLabel: `Recebidas WL`,
            secondLabel: 'Recebidas Cliente',
          }}
        />
      </Card>
    </Frame.Base>
  );
}
